module.exports = __webpack_public_path__ + "static/img/jianshiSkill.daab3aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/jianshiSkill.png
// module id = vPZI
// module chunks = 0